module.exports = __webpack_public_path__ + "static/img/y5.3d0cc16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/y5.png
// module id = OQ8S
// module chunks = 1